import { COVERGO_SAAS_DEV, COVERGO_EU_UAT, COVERGO_EU_PROD } from "../consts.js"



export const medisky_dev = {
	"medisky-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "medisky_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}

export const medisky_uat = {
	"medisky-studio.uat.eu.covergo.cloud": {
		appConfig: {
			tenantId: "medisky_uat",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_EU_UAT,
		fileSystem: {
			bucketName: "covergo-euce1-uat-medisky-uat"
		}
	},
}

export const medisky_prod = {
	"medisky-studio.eu.covergo.com": {
		appConfig: {
			tenantId: "medisky_prod",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_EU_PROD,
		fileSystem: {
			bucketName: "covergo-euce1-prod-medisky"
		}
	}
}


